import { useState, useEffect } from "react";
import TableAHSF from "../../../../Components/TableAHSF";

import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import PopupAHSF from "../../../../Components/PopupAHSF";
import { DeleteOtherSupportingParties } from "../../../../Redux/Reducers/Submitter/OtherSupportingParties";
import AddEditOtherSupport from "./AddEditOtherSupport";
import loadConfig from "../../../../Services/Api/ApiServices";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";

const OtherSupport = (props) => {
  const [jsonData, setJsonData] = useState({});
  const dispatch = useDispatch();
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [OtherSupportId, setOtherSupportId] = useState(null);
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
    };
  });
    const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
    const ApplicationInformation = useSelector(
      (state) => state.ApplicationInformationReducers.ApplicationInformation
    );
  const shouldDisableFields = !(
    ActiveRound == ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "supportingPartyName",
      ShowStatus: true,
      NmaeColumn: "الجهات الداعمة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "durationInMonths",
      ShowStatus: true,
      NmaeColumn: "المدة الزمنية (بالاشهر)",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "supportTypeName",
      ShowStatus: true,
      NmaeColumn: "نوع الدعم (مادي/عيني)",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "supportValue",
      ShowStatus: true,
      NmaeColumn: "قيمة الدعم",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma:true

      
    },
    {
      KeyName: "supportCoverage",
      ShowStatus: true,
      NmaeColumn: "بنود تغطية الدعم",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const M_ApplicationsBtns = [
    {
      Click: async (e) => {
        //console.log(e.target.value, "sssssssssssss");

        setOtherSupportId(e.target.value);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: !shouldDisableFields
        ? "bi bi-pencil-square"
        : "bi bi-view-list",
      // className: "bi bi-pencil-square",
      //   !shouldDisableFields
      //     ? "bi bi-pencil-square"
      //     : "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            const deleted = await dispatch(
              DeleteOtherSupportingParties(e.target.value)
            );
            if (deleted.payload) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الحذف بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      ShowStatus: !shouldDisableFields,

      // ShowStatus: true,
      //   !shouldDisableFields,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: <div>{<AddEditOtherSupport />}</div>,
    title: "الجهات الداعمة الاخرى لمشروع البحث المقترح إن وجد",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <AddEditOtherSupport
          otherSupportingPartiesId={OtherSupportId}
          canEdit="edit"
        />
      </div>
    ),
    title: "الجهات الداعمة الاخرى لمشروع البحث المقترح إن وجد",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  //console.log(state.TeamMembersPreviousExperiencePartnerships, "ghhhghhg");

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"otherSupportingPartiesId"}
        valueButtonAction={"otherSupportingPartiesId"}
        URL={`api/OtherSupportingParties/GetOtherSupportingPartiesListByAppGuid`}
        UrlBody={{
          applicationInformationId: props.applicationInformationId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الجهات الداعمة الاخرى لمشروع البحث المقترح إن وجد"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!shouldDisableFields}
        // tableBtn={true}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={M_ApplicationsBtns}
        ArrayNameDataColum={[]}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>
  );
};
export default OtherSupport;
